import { useQuery } from '@tanstack/react-query'
import { zetApi } from '@zet/network'

import { GetPrefilledDataRequest, IGetPrefilledDataResponse } from '../types'

export async function getPrefilledData(suppliedData: GetPrefilledDataRequest) {
  const { data } = await zetApi.get<IGetPrefilledDataResponse>(
    `customer/getCustomerPrefillDetails?customerId=${suppliedData?.customerId}`
  )
  return data?.data
}

export function useGetPrefilledData(suppliedData: GetPrefilledDataRequest) {
  return useQuery(
    ['getPrefilledData', suppliedData.customerId],
    () => getPrefilledData(suppliedData),
    {
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
    }
  )
}
